import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=2cff57ed"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cff57ed')) {
      api.createRecord('2cff57ed', component.options)
    } else {
      api.reload('2cff57ed', component.options)
    }
    module.hot.accept("./Contacts.vue?vue&type=template&id=2cff57ed", function () {
      api.rerender('2cff57ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrintSuite/Contacts.vue"
export default component.exports